module.exports = __webpack_public_path__ + "img/remind-icon2.fa6651de.png";